import React from 'react';
import { motion } from 'framer-motion';
import { flyoutTransition } from '../config';
import styled from 'styled-components';
const InvertedDark = styled.div.attrs({
    className: 'encore-inverted-dark-set',
}) `
  background-color: var(--background-base);
`;
export const FlyoutMenuContainer = ({ children, opened, onClose, }) => {
    return (React.createElement(InvertedDark, { className: "encore-inverted-dark-set", onMouseLeave: onClose, onBlur: onClose },
        React.createElement(motion.div, { initial: { opacity: 0 }, animate: { opacity: opened ? 1 : 0 }, exit: { opacity: 0 }, transition: flyoutTransition }, children)));
};
//# sourceMappingURL=FlyoutMenuContainer.js.map